import ResponsiveUtils from './ResponsiveUtils';

type TScrollOptions = {
	offset: number;
};

export default class ScrollUtils {
	/**
	 * Offsets for scrolling to an element. These are mostly the offsets caused by headers.
	 * For now they are hard coded here, since there is no better solution to get them (yet).
	 */
	readonly headerOffsets: Record<string, number> = {
		sm: 65,
		md: 100,
		lg: 70,
	};
	responsiveUtils = new ResponsiveUtils();

	constructor(headerOffsets?: Record<string, number>) {
		headerOffsets && (this.headerOffsets = headerOffsets);
	}

	init(): void {
		this.registerHashChangeListener();
		setTimeout(() => {
			this.scrollToHash();
		});
	}

	private hashChangeHandler(event: Event): void {
		event.preventDefault();
		this.scrollToHash();
	}

	private registerHashChangeListener(): void {
		// need to use arrow function in order to hand over `this`
		window.addEventListener('hashchange', (event: Event) => this.hashChangeHandler(event));
	}

	getHeaderOffset(): number {
		return this.headerOffsets[this.responsiveUtils.getViewport()];
	}

	private isVisible(element: HTMLElement) {
		return element.offsetHeight > 0;
	}

	private liesInDialog(element: Element) {
		let result = false;
		result = result || element.closest('.olb-overlay-container') !== null;
		result = result || element.closest('.quick-nav__box') !== null;
		return result;
	}

	scrollToHash() {
		if (window.location.hash.length > 1) {
			const hashId = window.location.hash.substr(1);
			// ignore this hash if it comes from clientside routing
			if (hashId.indexOf('/') === 1) {
				return;
			}
			const hashedElement = document.getElementById(hashId);
			if (hashedElement) {
				if (!this.isVisible(hashedElement)) return;
				if (this.liesInDialog(hashedElement)) return;
				const scrollTarget = hashedElement.getBoundingClientRect().top;
				const offset = this.getHeaderOffset();
				this.scrollTo(scrollTarget, { offset });
			}
		}
	}

	scrollTo(target: number, options?: TScrollOptions) {
		!options &&
			(options = {
				offset: 0,
			});
		let scrollTarget = target;
		scrollTarget -= options.offset;
		scrollTarget += window.scrollY;
		if (scrollTarget < 160 && this.responsiveUtils.isLgUp()) {
			scrollTarget = 0;
		}
		window.scrollTo({ top: scrollTarget });
	}

	scrollToTop() {
		window.scroll({
			behavior: 'smooth',
			left: 0,
			top: 0,
		});
	}
}
